import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  dialogTitle: {
    textAlign: 'center',
  },
});
